import { Pipe, PipeTransform } from '@angular/core';
import { Connectors } from '@interfaces/connector';

/**
 * Filters an array of objects based on a search term and a specified field.
 * @param value The array of objects to filter.
 * @param field The field to search for the search term.
 * @param term The search term to filter the array with.
 * @returns The filtered array of objects.
 */
@Pipe({
  name: 'filterOptions',
  pure: false,
  standalone: false,
})
export class FilterOptionsPipe implements PipeTransform {
  transform<T extends { [key: string]: any }>(value: T[] | null | undefined, fields: string[], term: string) {
    if (!term) {
      return value;
    }
    if (!value) {
      return [];
    }
    return value.filter((el) =>
      fields.some((field) => typeof el[field] === 'string' && el[field].toLowerCase().includes(term.toLowerCase())),
    );
  }
}

// A pipe that filters the connectors by status (is_enabled or !is_enabled ). that is applied to ngFor in the template
@Pipe({
  name: 'filterConnectors',
  standalone: false,
})
export class FilterConnectorsPipe implements PipeTransform {
  transform(connectors: Connectors[], filter: string): Connectors[] {
    if (!connectors) return [];
    return connectors.filter((connector) => {
      switch (filter) {
        case 'active':
          return connector.is_enabled;
        case 'inactive':
          return !connector.is_enabled;
        case 'pending':
          return !connector.is_logged_in;
        default:
          return true;
      }
    });
  }
}
